import React from 'react'
import styled from 'styled-components'
import { SvgAttr } from '../SvgAttr/SvgAttr'

export const IconGift = ({
  classes = '',
  styles,
  width = '40px',
  height = '40px',
  color = 'currentColor',
}) => {
  return (
    <Svg
      viewBox='0 0 72 72'
      className={classes}
      styles={styles}
      width={width}
      height={height}
      xmlns='http://www.w3.org/2000/svg'
      version='1.1'
    >
      <title>Gift</title>
      <Path
        color={color}
        d='M65.22,24.48s-.27-1.79-1.38-1.79h-16.27c2.47-1.13,6.35-3.6,7.01-6.65.33-1.5-.13-2.93-1.37-4.23-3.47-3.64-10.01-2.37-13.7,1.05-1.69,1.57-2.48,3.26-3.31,5.06-.16.35-.33.7-.5,1.06-.16-.35-.3-.71-.45-1.08-.33-.83-.68-1.68-1.19-2.5-1.74-2.78-4.95-5-8.17-5.64-2.46-.49-4.75-.07-6.6,1.24-2.25,1.58-2.53,3.38-2.38,4.61.38,2.99,3.68,5.78,6.59,6.89l.49.2H7.54l-.82.82v10.19l.04.25c.35.97,1.8.94,3.34.89v26.68l.11.18c.46.75,1.15.75,1.52.75,1.98,0,8.5-.02,16.27-.04,11.44-.03,25.58-.07,31.89-.07.4,0,1.67-.54,1.67-1.29v-26.2c1.48.02,2.65-.03,3.24-.61.23-.23.35-.52.35-.83,0-.19.01-.75.03-1.5.07-3.32.13-6.63.03-7.4ZM61.68,25.56v6.5h-18.6v-6.5h18.6ZM13.39,59.4v-24.58h15.21v24.58h-15.21ZM28.73,25.6v6.47H10v-6.47h18.72ZM50.87,16.5c-1.8,3.45-8.12,4.62-12.3,5.39-.14.03-.28.05-.42.08,1.17-3.84,4.18-9.55,9.21-9.55.1,0,.19,0,.29,0,1.38.06,2.69.77,3.26,1.76.41.71.4,1.49-.03,2.31ZM39.54,25.48v33.92h-7.4V25.48h7.4ZM33.24,21.95c-.4-.08-.81-.15-1.22-.23-3.76-.7-7.64-1.42-10.27-3.9-1.38-1.3-1.8-2.59-1.18-3.65.55-.94,1.91-1.65,3.56-1.65.58,0,1.21.09,1.84.29,3.98,1.25,5.86,4.54,7.27,9.14ZM43.08,59.4v-24.58h15.21v24.58h-15.21Z'
      />
    </Svg>
  )
}

const Svg = styled(SvgAttr)`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  ${(props) => props.styles}
`

const Path = styled.path`
  transition: all 0.2s ease-in-out;
  fill: ${(props) => props.color};
`
